<template>
  <div class="w-100 h-100">
    <b-container fluid>
      <h2 class="tw-mb-0 text-aegis-dk">Subject Followup</h2>
      <p class="tw-italic tw-text-gray-700">View/Filter Followup data by period/type/status.</p>
    </b-container>

    <b-container fluid>
      <b-row>
        <b-col cols="auto">
          <b-form-select
            v-model="studyPhase"
            :options="studyPhaseOptions"
          ></b-form-select>
        </b-col>
        <b-col>
          <b-form-select v-model="clinic_name" :options="clinic_name_options"></b-form-select>
        </b-col>
        <b-col>
          <b-form-select v-model="followup_period" :options="followup_period_options"></b-form-select>
        </b-col>
        <b-col v-if="showFollowUpDropDown">
          <b-form-select v-model="followup" :options="followup_options"></b-form-select>
        </b-col>
        <b-col>
          <b-form-select v-model="followup_type" :options="followup_type_options"></b-form-select>
        </b-col>
        <b-col cols="auto">
          <b-button
            @click="downloadFile()"
            variant="secondary"
            class="px-3"
            :disabled="!filteredItems.length"
          >Download ALL</b-button>
        </b-col>
      </b-row>
    </b-container>
    <br />

    <b-table
      show-empty
      ref="table"
      striped
      hover
      responsive
      :items="items"
      :fields="fields"
      :busy.sync="loading"
      :current-page="options.currentPage"
      :per-page="options.perPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :filter-function="filterFunction"
      :filter="filter"
      @filtered="onFiltered"
    ></b-table>

    <b-pagination
      v-model="options.currentPage"
      :total-rows="options.totalRows"
      :per-page="options.perPage"
      align="right"
      size="sm"
      class="my-0"
    ></b-pagination>
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

import * as _ from "lodash";

export default {
  mixins: [DashboardBaseTemplate],
  data() {
    return {
      options: {
        currentPage: 1,
        totalRows: 0,
        perPage: 20,
      },
      loading: false,
      filter: null,
      fields: [
        { key: "subject_id", sortable: true },
        { key: "clinic_name", sortable: true },
        { key: "cluster_number", sortable: true },
        { key: "followup", sortable: true },
        { key: "period", sortable: true },
        { key: "start", sortable: true },
        { key: "end", sortable: true },
        { key: "type", sortable: true },
        { key: "status", sortable: true },
      ],
      items: [],
      filteredItems: [],
      sortBy: "id",
      sortDesc: false,
      title: "",
      totalItems: 0,
      stacked: false,
      studyPhase: 'ALL',
      studyPhaseOptions: ['ALL', 'Baseline', 'Cohort 1', 'Cohort 2'],
      followup: "ALL",
      followup_type: "ALL",
      followup_period: "ALL",
      followup_period_options: [
        { value: "ALL", text: "ALL" },
        { value: "F1", text: "Followup 1" },
        { value: "F2", text: "Followup 2" },
        { value: "F3", text: "Followup 3" },
        { value: "F4", text: "Followup 4" },
        { value: "F5", text: "Followup 5" },
        { value: "F6", text: "Followup 6" },
        { value: "F7", text: "Followup 7" },
        { value: "F8", text: "Followup 8" },
        { value: "F9", text: "Followup 9" },
        { value: "F10", text: "Followup 10" },
        { value: "F11", text: "Followup 11" },
        { value: "F12", text: "Followup 12" },
        { value: "F13", text: "Followup 13" },
        { value: "F14", text: "Followup 14" },
        { value: "F15", text: "Followup 15" },
        { value: "F16", text: "Followup 16" },
        { value: "F17", text: "Followup 17" },
        { value: "F18", text: "Followup 18" },
        { value: "F19", text: "Followup 19" },
        { value: "F20", text: "Followup 20" },
        { value: "F21", text: "Followup 21" },
        { value: "F22", text: "Followup 22" },
        { value: "F23", text: "Followup 23" },
        { value: "F24", text: "Followup 24" },
      ],
      followup_options: [
        { value: "ALL", text: "Compound + Clinic" },
        { value: "Compound", text: "Compound" },
        { value: "Clinic", text: "Clinic" },
      ],
      followup_type_options: [
        { value: "ALL", text: "ALL" },
        { value: "Compound", text: "Completed Followups (Compound)" },
        { value: "Clinic", text: "Completed Followups (Clinic)" },
        // {value: 'Late', text: 'Late Followups'},
        { value: "Missed", text: "Missed Followups" },
        { value: "Incomplete", text: "Incomplete Followups" },
        { value: "LTFU", text: "LTFU Followups" },
        { value: "Clinic, Sick", text: "Clinic, Sick Followups" },
      ],
      clinic_name_options: ['ALL Clinics'],
      clinic_name: 'ALL Clinics'
    };
  },
  created() {
    this.find();

    if(this.STUDY == 'mali'){
      this.studyPhaseOptions = ['ALL', 'Baseline', 'Intervention'];
      this.followup_options = ['ALL', 'Bi-Weekly', 'Monthly'];
      this.followup_period_options = [
        { value: "ALL", text: "ALL" },
        { value: "F1", text: "Followup 1" },
        { value: "F2", text: "Followup 2" },
        { value: "F3", text: "Followup 3" },
        { value: "F4", text: "Followup 4" },
        { value: "F5", text: "Followup 5" },
        { value: "F6", text: "Followup 6" },
        { value: "F7", text: "Followup 7" },
        { value: "F8", text: "Followup 8" },
        { value: "F9", text: "Followup 9" },
        { value: "F10", text: "Followup 10" },
        { value: "F11", text: "Followup 11" },
        { value: "F12", text: "Followup 12" },
        { value: "F13", text: "Followup 13" },
        { value: "F14", text: "Followup 14" },
        { value: "F15", text: "Followup 15" },
        { value: "F16", text: "Followup 16" },
        { value: "F17", text: "Followup 17" },
        { value: "F18", text: "Followup 18" },
        { value: "F19", text: "Followup 19" },
        { value: "F20", text: "Followup 20" },
        { value: "F21", text: "Followup 21" },
        { value: "F22", text: "Followup 22" },
        { value: "F23", text: "Followup 23" },
        { value: "F24", text: "Followup 24" },
        { value: "F25", text: "Followup 25" },
        { value: "F26", text: "Followup 26" },
        { value: "F27", text: "Followup 27" },
        { value: "F28", text: "Followup 28" },
        { value: "F29", text: "Followup 29" },
        { value: "F30", text: "Followup 30" },
        { value: "F31", text: "Followup 31" },
        { value: "F32", text: "Followup 32" },
        { value: "F33", text: "Followup 33" },
        { value: "F34", text: "Followup 34" },
        { value: "F35", text: "Followup 35" },
        { value: "F36", text: "Followup 36" },
        { value: "F37", text: "Followup 37" },
        { value: "F38", text: "Followup 38" },
        { value: "F39", text: "Followup 39" },
        { value: "F40", text: "Followup 40" },
        { value: "F41", text: "Followup 41" },
        { value: "F42", text: "Followup 42" },
        { value: "F43", text: "Followup 43" },
        { value: "F44", text: "Followup 44" },
        { value: "F45", text: "Followup 45" },
        { value: "F46", text: "Followup 46" },
        { value: "F47", text: "Followup 47" },
        { value: "F48", text: "Followup 48" },
      ]
    }
  },
    computed: {
    showFollowUpDropDown() {
      // If the study is Kenya and the follow up period is 'All', show the drop-down.
      // We don't want this condition in Mali
      if(this.STUDY == 'kenya'){
        if(this.followup_period == 'ALL'){
          return true;
        } else {
          return false;
        }
      }
      return true; // always show it if it's Mali
    }
  },
  watch: {
    followup_period: function () {
      this.filter = "followup_period";
    },
    followup: function () {
      this.filter = "followup";
    },
    followup_type: function () {
      this.filter = "followup_type";
    },
    studyPhase: function () {
      this.filter = "studyPhase";
    },
    clinic_name: function () {
      this.filter = "clinic_name";
    },
  },
  methods: {
    find() {
      const that = this;
      that.loading = true;

      return HTTP.get("/kenya/metrics/subject-followup")
        .then((response) => {
          that.items = response.data;
          that.options.totalRows = that.items.length;
          that.filteredItems = that.items;
          that.loading = false;

          that.clinic_name_options = that.clinic_name_options.concat(_.uniq(_.map(that.items, 'clinic_name')));
        })
        .catch((error) => {
          that.loading = false;
          HandleErrors.HandleErrors(error);
        });
    },
    filterFunction(row, filter) {
      if(this.studyPhase !== "ALL" && row.study_phase !== this.studyPhase) {
          return false;
      }

      if (this.followup_period !== "ALL" && row.period !== this.followup_period) {
        return false;
      }

      if (this.followup !== "ALL" && row.followup !== this.followup) {
        return false;
      }

      if (this.followup_type !== "ALL" && row.type !== this.followup_type) {
        return false;
      }

      if(this.clinic_name !== 'ALL Clinics' && row.clinic_name !== this.clinic_name) {
          return false
      }


      return true;
    },
    downloadFile: function () {
      const that = this;
      var columns = _.keys(that.filteredItems[0]);
      var csv = columns.join(",") + "\n";
      that.filteredItems.forEach(function (row) {
        let row_arr = [];
        _.each(_.values(row), function(element) {
          row_arr.push(element.replace(",", " /"))
        })
        csv += row_arr.join(",");
        csv += "\n";
      });

      var hiddenElement = document.createElement("a");
      hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
      hiddenElement.target = "_blank";
      hiddenElement.download = "subject-followup.csv";
      hiddenElement.click();
    },
    onFiltered(filteredItems) {
      this.filteredItems = filteredItems;
      this.options.totalRows = filteredItems.length;
    },
  },
};
</script>

<style>
</style>